'use client';

import { mediaRefUrl } from "@/app/features/shared/__to_be_integrated/types/general/media/media-helper";
import { useSiteGuidedToursEditor } from "@/app/features/sites/guided-tours/contexts/GuidedToursEditor";
import LoadingSpinner from "@/app/__to_be_integrated/_____components/_NEW/LoadingSpinner";
import { memo, useCallback } from "react";
import { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";
import MediaView from "@/app/features/shared/media-view/ui/public/MediaView.public";
import { PLACEHOLDER_IMAGE } from "@/app/types/common/constants";
import {
    GuidedToursHeaderFrame,
    GuidedToursHeroFrame
} from "@/app/features/sites/guided-tours/ui/shared/GuidedToursViewFrames";
import { Typography } from "@mui/material";
import GuidedToursTilesEditable from "@/app/features/sites/guided-tours/ui/editable/GuidedToursTiles.editable";
import DefaultHeroIntroContentEditable
    from "@/app/features/shared/intros/hero/ui/editable/DefaultHeroIntroContent.editable";

const backgroundMediaSlots = {
    root: { className: 'home-hero-image flex flex-auto size-full z-0' },
    image: {
        style: {
            objectFit: 'cover' as const,
        },
        quality: 75,
        priority: true,
        fetchPriority: 'high' as const,
        loading: 'eager' as const,
        sizes: '100vw',
    },
};

const BackgroundMedia = memo(
    function BackgroundMedia({
        src,
    }: {
        src: MediaRef;
    }) {
        return (
            <MediaView
                src={src}
                fill
                showLoadingSpinner={false}
                slots={backgroundMediaSlots}
            />
        );
    },
    (prev, next) => mediaRefUrl(prev.src) === mediaRefUrl(next.src)
)

export default function GuidedToursEditable() {
    const { isLoading, editable, updateEditable, errorForField } = useSiteGuidedToursEditor();

    const updateTitle = useCallback((title: string)  => {
        updateEditable({ intro: { title } });
    }, [updateEditable]);

    const updateSubtitle = useCallback((subtitle: string)  => {
        updateEditable({ intro: { subtitle } });
    }, [updateEditable]);

    const updateDescription = useCallback((description: string | undefined) => {
        updateEditable({ intro: { description } });
    }, [updateEditable]);

    if (isLoading || !editable) return <LoadingSpinner />;
    if (!editable) return null;

    return (
        <>
            <GuidedToursHeroFrame
                content={
                    <DefaultHeroIntroContentEditable
                        data={editable.intro}
                        onTitleChange={updateTitle}
                        onSubtitleChange={updateSubtitle}
                        onDescriptionChange={updateDescription}
                        errorForField={errorForField}
                    />
                }
                background={
                    <BackgroundMedia
                        src={editable?.intro.image || PLACEHOLDER_IMAGE}
                    />
                }
            />
            <GuidedToursHeaderFrame>
                <Typography component="h2" variant="h1">
                    Themen
                </Typography>
            </GuidedToursHeaderFrame>
            <GuidedToursTilesEditable />
        </>
    )
}
